
import { KineticText } from './KineticText';

const skillsRow1 = [
    "React", "TypeScript", "Node.js", "Docker", "Python", "AWS", "GraphQL", "Next.js"
];

const skillsRow2 = [
    "Tailwind", "Three.js", "Framer Motion", "PostgreSQL", "Redis", "Linux", "Git", "CI/CD"
];

export function TechStack() {
    return (
        <div className="relative py-20 flex flex-col items-center justify-center overflow-hidden w-full">
            <h3 className="text-2xl font-bold text-white mb-12 font-mono tracking-widest text-center flex gap-3 justify-center flex-wrap">
                <KineticText text="CORE" className="text-emerald-500" />
                <KineticText text="PROTOCOLS" className="text-white" />
            </h3>

            {/* Gradient Masks */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-tech-bg to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-tech-bg to-transparent z-10 pointer-events-none" />

            {/* Row 1 - Scroll Left */}
            <div className="flex w-full mb-8 overflow-hidden relative group">
                <div className="flex animate-marquee whitespace-nowrap group-hover:pause">
                    {[...skillsRow1, ...skillsRow1, ...skillsRow1, ...skillsRow1].map((skill, i) => (
                        <div
                            key={`r1-${i}`}
                            className="mx-4 px-6 py-3 bg-white/5 border border-white/10 rounded-full cursor-pointer backdrop-blur-sm hover:bg-emerald-500/10 hover:border-emerald-500/30 transition-all"
                        >
                            <span className="text-gray-300 font-mono text-sm tracking-wide font-bold hover:text-emerald-400 transition-colors">
                                {skill}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="flex absolute top-0 animate-marquee2 whitespace-nowrap group-hover:pause">
                    {[...skillsRow1, ...skillsRow1, ...skillsRow1, ...skillsRow1].map((skill, i) => (
                        <div
                            key={`r1-d-${i}`}
                            className="mx-4 px-6 py-3 bg-white/5 border border-white/10 rounded-full cursor-pointer backdrop-blur-sm hover:bg-emerald-500/10 hover:border-emerald-500/30 transition-all"
                        >
                            <span className="text-gray-300 font-mono text-sm tracking-wide font-bold hover:text-emerald-400 transition-colors">
                                {skill}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Row 2 - Scroll Right */}
            <div className="flex w-full overflow-hidden relative group">
                <div className="flex animate-marquee-reverse whitespace-nowrap group-hover:pause">
                    {[...skillsRow2, ...skillsRow2, ...skillsRow2, ...skillsRow2].map((skill, i) => (
                        <div
                            key={`r2-${i}`}
                            className="mx-4 px-6 py-3 bg-white/5 border border-white/10 rounded-full cursor-pointer backdrop-blur-sm hover:bg-emerald-500/10 hover:border-emerald-500/30 transition-all"
                        >
                            <span className="text-gray-300 font-mono text-sm tracking-wide font-bold hover:text-emerald-400 transition-colors">
                                {skill}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="flex absolute top-0 animate-marquee2-reverse whitespace-nowrap group-hover:pause">
                    {[...skillsRow2, ...skillsRow2, ...skillsRow2, ...skillsRow2].map((skill, i) => (
                        <div
                            key={`r2-d-${i}`}
                            className="mx-4 px-6 py-3 bg-white/5 border border-white/10 rounded-full cursor-pointer backdrop-blur-sm hover:bg-emerald-500/10 hover:border-emerald-500/30 transition-all"
                        >
                            <span className="text-gray-300 font-mono text-sm tracking-wide font-bold hover:text-emerald-400 transition-colors">
                                {skill}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Animated Background Rings */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-emerald-500/5 rounded-full animate-[spin_60s_linear_infinite] pointer-events-none" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-emerald-500/10 rounded-full animate-[spin_40s_linear_infinite_reverse] pointer-events-none" />
        </div>
    );
}

